import React, { Fragment, useEffect } from "react";
import { Event, PageConfiguration } from "./index";
import NotifiedBellIcon from "./NotifiedBellIcon";
import {
  OrganizationHeaderContextConsumer,
  OrganizationHeaderContextInterface
} from "./CustomizeLandingPage";
import Color from "color";
import ContrastForegroundUtility from "../../utils/ContrastForegroundUtility";

declare const $: any;

const EventCoverPhoto = ({
  event,
  editMode,
  pageConfiguration,
  className,
  showUpdateEventCoverPopup
}: {
  event: Event;
  editMode: boolean;
  pageConfiguration: PageConfiguration;
  className: string;
  showUpdateEventCoverPopup: Function;
}) => {
  useEffect(() => {
    $(".disabled").tooltip();
  });

  const editModeView = () => {
    return (
      <OrganizationHeaderContextConsumer>
        {context =>
          context && (
            <div
              className="ev-card-cover-btn-div"
              style={{ display: "inline-block", cursor: "not-allowed" }}
            >
              <button
                className="ev-card-cover-btn"
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  showUpdateEventCoverPopup(event);
                }}
                style={{
                  color: pageConfiguration.primaryColor,
                  border: `1px solid ${pageConfiguration.primaryColor}`,
                  backgroundColor: ContrastForegroundUtility.lightenColor(
                    pageConfiguration.primaryColor
                  )
                }}
              >
                {event.coverPhoto ? "Change cover image" : "Select cover image"}
              </button>
            </div>
          )
        }
      </OrganizationHeaderContextConsumer>
    );
  };

  const coverStyle = () => {
    if (event.coverPhoto)
      return {
        backgroundImage: `url("${event.coverPhoto}")`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "top"
      };
    else
      return {
        backgroundColor: ContrastForegroundUtility.lightenColor(
          pageConfiguration.primaryColor
        )
      };
  };

  const coverPhotoInnerBlock = () => {
    if (editMode) return editModeView();
    else if (!event.coverPhoto)
      return (
        <Fragment>
          <NotifiedBellIcon color={pageConfiguration.primaryColor} />
          <p className="ev-card-noti-p">No photos uploaded yet</p>
          <button className="ev-card-noti-btn">Get Notified</button>
        </Fragment>
      );
    else return null;
  };

  return (
    <div className={className} style={coverStyle()}>
      {coverPhotoInnerBlock()}
    </div>
  );
};
export default EventCoverPhoto;
